export const makeFriendlyTitleFromPath = (path: string) :string => {
    let friendlyPath = path.replace("/", "").replaceAll("-", " ").split("/")[0];
    if (friendlyPath.includes("account"))
        friendlyPath = "account";
    if (friendlyPath.includes("patient list"))
        friendlyPath = "patient list";
    if (friendlyPath.includes("compose new message"))
        friendlyPath = "compose new message";

    return friendlyPath;
}


